import Vue from 'vue'
import VueRouter from 'vue-router'
import CustomerDashboard from '@/views/CustomerDashboard'
import ReportsPage from '@/views/ReportsPage'
import UnauthorizedView from '@/views/UnauthorizedView'

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: 'CustomerDashboard',
        component: CustomerDashboard,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: "/reports",
        name: 'ReportsPage',
        component: ReportsPage,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: "/unauthorizedUser",
        name: 'UnauthorizedView',
        component: UnauthorizedView,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '*',
        redirect: '/',
        meta: {
            requireAuth: true,
        },
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
